import { useEffect, useState } from 'react';
import { View } from 'react-native';
import { Text } from '@/components/Text';
import store from '../../stores/store';
import { Input } from '@/components/ui/therapist/Input';

export function ConnectPatient({ code, setCode }) {
  const [isValidCode, setIsValidCode] = useState(false);

  function handleChangePatientCode(value) {
    setCode(value);
    store.getState().patient.code = value;
    if ((!value && typeof value !== 'string') || value.length < 6) {
      return setIsValidCode(false);
    }
    const characters =
      '!123456789abcdefghijk@mn&pqrstuvwxyzABCDEFGH$JKLMN#PQRSTUVWXYZ-_';
    const len = value.length;
    for (let i = 0; i < len; i++) {
      if (characters.indexOf(value[i]) === -1) {
        return setIsValidCode(false);
      }
    }
    return setIsValidCode(true);
  }

  useEffect(() => {
    setCode(store.getState().patient.code);
    if (store.getState().patient.code) {
      setIsValidCode(true);
    }
  }, []);

  return (
    <View>
      <Text
        style={{
          fontSize: 14,
          paddingBottom: 0,
        }}
      >
        Geben Sie hier den Patienten-Code ein, der in der Aphasie-App auf dem
        Patienten-Gerät angezeigt wird.
      </Text>

      <View style={{ paddingVertical: 16 }}>
        <View style={{ paddingVertical: 16 }}>
          <Input
            label="Patienten-Code"
            value={code}
            onChange={handleChangePatientCode}
            status={isValidCode ? 'validated' : 'warning'}
            statusMessage={isValidCode ? '' : 'Kein Patienten-Code'}
            required
          />
        </View>
      </View>
    </View>
  );
}
